import React, { useState,useContext,useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Erreurs from '../../../Erreurs/Erreurs';
import moment from 'moment';
import Api from '../../../../services/Api';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import { ElementContext } from '../../../../services/Context/Context';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const StepThree = ({ prevStep,nextStep,paiement,setPaiement }) => {
  const { 
    handleSubmit,
    formState: { errors },
    setError: setFormError,
    control,
    trigger,
    clearErrors,
    setValue,
  } = useForm(); 
  const baseURL = process.env.REACT_APP_URL.replace('api/','') + 'storage/'; 
  const { elementsData } = useContext(ElementContext); 
  const { categories,marques,modeles } = elementsData; 
  const [ categorie,setCategorie ] = useState('');
  const [ isModalOpen,setIsModalOpen ] = useState(false);
  const api = new Api();
  const [erreurs,setErreurs] = useState([]);
  const [isLoading,setIsLoading ] = useRecoilState(loadingState);
  const [ selectedMarque,setSelectedMarque ] = useState('');
  const [ selectedModele,setSelectedModele ] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const cat = categories.filter((p) => p.categorie_id == paiement.infovehicule.categorie)[0];
    if( cat ){
      setCategorie(cat.nomCategorie)
    }
    setSelectedMarque(marques.find(p => p.id == paiement.infovehicule.marque));
    setSelectedModele(modeles.find(p => p.id == paiement.infovehicule.modele ));

},[paiement.infovehicule.categorie]);
const openFile = () => {
 
  if( typeof paiement?.infovehicule.dossier[0] === 'object' ){
    const pdfUrl = URL.createObjectURL(paiement?.infovehicule.dossier[0]);
    window.open(pdfUrl, '_blank');
     // Optional: Revoke the object URL after some time to free up memory
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
  }
  else if( typeof paiement?.infovehicule.dossier[0] === 'string' ){
    window.open(baseURL + paiement?.infovehicule.dossier[0], '_blank');
  }
 
 
 }   
 const submitForm = async (data) => {
    console.log(paiement);
    try{
        var formData = new FormData(); setIsLoading(true);
        setErreurs([]);
        formData.append("id",paiement.id);
        Object.entries(paiement.infovehicule).forEach(([key, value]) => {
          if (key !== 'dossier') {
              formData.append(`infovehicule[${key}]`, value);
          }
      });   
      // Traitement spécifique pour infovehicule.dossier (les fichiers)
      if (Array.isArray(paiement.infovehicule.dossier)) {
          paiement.infovehicule.dossier.forEach((file, index) => {
            formData.append(`infovehicule[dossier][]`, file); // 👈 fichier réel
        });
      }
     // console.log(formData);
      const response = await api.apiData('post',`/paiement/apc/invoice?invoice_id=${paiement.id}`,formData);
      if(response.status === 200){
         toast.success("Modification effectuée avec succès."); 
         navigate(`/apc/invoice/${paiement.id}`);
         
      }
      else{
        setErreurs(response.errors);
      }
      // if(response.status === 200){
        
      // }
    }catch(error){
      console.log(error);
    }
    finally{
      setIsLoading(false);
    }
  }
 // console.log(errors)
  return (
    <div className='step-component step-three'>
        <h1>Récapitulatif</h1>
        <form onSubmit={handleSubmit(submitForm)}>
         <div className='step__details'>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Type de demandeur</p> 
                <p>{ paiement.typeDemandeur.charAt(0).toUpperCase() +  paiement.typeDemandeur.slice(1) }</p>
              </div>  
              <div className='step__details__group__elem'>
                <p>Prenom et Nom</p> 
                <p>{ paiement.demandeur.fullName }</p>
              </div>
           </div>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Téléphone</p> 
                <p>{ paiement.demandeur.telephone }</p>
              </div>  
              <div className='step__details__group__elem'>
                <p>Adresse</p> 
                <p>{ paiement.demandeur.adresse || "Non fournie" }</p>
              </div>
           </div>

           <div className='step__details__group'>  
              <div className='step__details__group__elem'>
                <p>type d'autorisation</p> 
                <p>{ paiement.infovehicule.paysDestination === "Guinée" ? "Circulation Temporaire":"Transit"}</p>
              </div>
              <div className='step__details__group__elem'>
                <p>Categorie de Véhicule</p> 
                <p>{ categorie }</p>
              </div>
           </div>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Marque</p> 
                <p>{ selectedMarque.title || "Non fournie" }</p>
              </div>
              <div className='step__details__group__elem'>
                <p>Modèle</p> 
                <p>{ selectedModele.title || "Non fournie"}</p>
              </div>
           </div>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Numéro de chassis</p> 
                <p>{ paiement.infovehicule?.numeroChassis?.join(", ") || "Non fourni" }</p>
              </div>
              <div className='step__details__group__elem'>
                <p>Couleur</p> 
                <p>{ paiement.infovehicule.couleur?.charAt(0).toUpperCase() + paiement.infovehicule.couleur?.slice(1) || paiement.infovehicule.otherColor?.charAt(0).toUpperCase() + paiement.infovehicule.otherColor?.slice(1) || "Non fourni" }</p>
              </div>
           </div>
           <div className='step__details__group'>
            <div className='step__details__group__elem'>
              <p>PTAC(kg)</p> 
              <p>{ paiement.infovehicule.ptac }</p>
            </div>
            <div className='step__details__group__elem'>
               <p>Puissance (CV) </p>
               <p>{ paiement.infovehicule.puissanceFiscale || 0 }</p>
            </div>
           </div>
           <div className='step__details__group'>
            <div className='step__details__group__elem'>
              <p>Poids à vide (kg)</p> 
              <p>{ paiement.infovehicule.poidsAVide || 0 }</p>
            </div> 
            <div className='step__details__group__elem'>
              <p>Poids Total Roulant (kg)</p> 
              <p>{ paiement.infovehicule.poidsTotalRoulant || 0 }</p>
            </div> 
           </div>
           <div className='step__details__group'>
             <div className='step__details__group__elem'>
               <p>Charge Utile</p> 
               <p>{ paiement.infovehicule.chargeUtile || 0 }</p>
             </div>
              <div className='step__details__group__elem'>
                <p>Date de prémière mise en circulation</p> 
                <p>{ moment(paiement.infovehicule.dateMiseCirculation).format("DD/MM/YYYY") }</p>
              </div> 
           </div>
           <div className='step__details__group'>
            <div className='step__details__group__elem'>
                <p>Pays de provenance</p> 
                <p>{ paiement.infovehicule.paysProvenance }</p>
              </div>
             <div className='step__details__group__elem'>
                <p>Pays de destination</p> 
                <p>{ paiement.infovehicule.paysDestination }</p>
              </div>
              
           </div>
           <div className='dossier__image' onClick={() => openFile()}>
              <h4>Voir les documents</h4> 
           </div>
          </div>
        <Erreurs validation={erreurs} />   
        <div className="buttons">
          <button className="secondary" onClick={prevStep}>
            Précedent
          </button>
          <button className="" type='submit'>
            Terminer
          </button>
        </div>
       </form> 
      
    </div>
  )
}

export default StepThree